module.exports = __webpack_public_path__ + "static/media/016-Rollstuhl_ID_2.e85b0eae.mp3";